import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const MuiFooterButtonsWrapper = styled.div`
  .container-bottom {
    margin-bottom: 32px;
    padding: 32px 16px 20px 0px;
    align-items: center;
    display: flex;
    background-color: ${COLORS.cirrus_white};
    justify-content: flex-end;
    ${responsive.MOBILE`
         margin-top:24px;
         padding-right: 0px;
         flex-direction: column-reverse;
         justify-content: center;
      `}
  }
  .bottom-button-clear {
    ${responsive.MOBILE`
        margin-top:16px;
        width: 100%;
        margin-left: 0px;
      `}
  }
  .bottom-button-continue {
    margin-left: 16px;
    ${responsive.MOBILE`
        margin-top:16px;
        width: 100%;
        margin-left: 0px;
      `}
  }
`;
